import React from 'react';
import { PropTypes } from 'prop-types';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Typography } from '@mui/material';
import * as icons from 'mdi-material-ui';

const arrowSx = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 20px)',
    cursor: 'pointer',
    padding: 0,
    transition: 'display .3s allow-discrete',
    height: 0,
};

const CarouselArrow = ({ onClick, side, show }) => {
    let ArrowIcon = side === 'left' ? icons.ChevronLeft : icons.ChevronRight;
    return (
        <Typography
            onClick={onClick}
            sx={theme => ({
                ...arrowSx,
                [side]: '-5px',
                color: 'primary.main',
                display: show ? 'inline-block' : 'none',
                '&:hover,:focus': {
                    color: theme.palette.primary.dark,
                },
            })}
        >
            <ArrowIcon sx={{ fontSize: '32px' }} />
        </Typography>
    );
};

CarouselArrow.propTypes = {
    onClick: PropTypes.func.isRequired,
    show: PropTypes.bool,
    side: PropTypes.oneOf(['left', 'right']),
};

const CustomCarousel = ({ children, ...rest }) => {
    return (
        <Carousel
            containerClass="carousel-container"
            showThumbs={false}
            showIndicators={false}
            showStatus={false}
            interval={15000}
            autoPlay
            infiniteLoop
            renderArrowPrev={(onClick, hasPrev) => (
                <CarouselArrow show={hasPrev} onClick={onClick} side="left" />
            )}
            renderArrowNext={(onClick, hasNext) => (
                <CarouselArrow show={hasNext} onClick={onClick} side="right" />
            )}
            {...rest}
        >
            {children}
        </Carousel>
    );
};

CustomCarousel.propTypes = {
    children: PropTypes.node,
};

export default CustomCarousel;
